import {Button, Link, useAnalytics} from 'bigdatr-style';
import {Flex} from 'bigdatr-style/layout';
import React from 'react';
import rqApi from '~/api';
import {useRoutes} from '~/app/Router';

export default function CreativeIndexLaunch() {
    const analytics = useAnalytics();
    const submitTrackingForm = rqApi.useSubmitHubspotForm();
    const routes = useRoutes();

    return (
        <>
            <p>
                Now available in the meta data of each creative in your Advertising Creative
                library, Creative Index gives you daily insights into advertiser activity, right
                down to when individual creatives were most and least prominent in the marketplace.
            </p>
            <p>
                Using this daily activity data, you can easily identify competitor creative cycles,
                monitor ad activity that may impact your brand visibility, and compare Creative
                Index trends across channels and publishers to inform your strategy.
            </p>

            <p>
                Want to learn more? <Link onClick={() => analytics.chat()}>Chat with us</Link> or{' '}
                <Link href="https://bigdatr.com/book-a-demo/" target="_blank">
                    request a team walkthrough →
                </Link>
            </p>

            <Flex>
                <Button
                    onClick={() => {
                        submitTrackingForm.mutate({formId: '9c4bd200-c25e-418a-9505-79af1e87b984'});
                        routes.singleCreative.push({creativeId: '1584192'});
                    }}
                >
                    View Creative Index
                </Button>
            </Flex>
        </>
    );
}
